import React from 'react';

/*
 *  @Author:        Sergio Balaguer Carmona
 *  @Description:   Stateless component that renders a Cursor (by default points to the right).
 */

const Cursor = ( props ) => {

    return (<g id="Group_1588" data-name="Group 1588" transform="translate(-383.25 -3455.25)">
            <path id="Path_458" data-name="Path 458" d="M3.5,3.5,63.593,63.593,3.5,123.5"
                  transform="translate(381.5 3453.5)"/>
        </g>
    )
};

export default Cursor;

